<template>
  <div>
    <div>
      <div class="chat" v-chat-scroll="{ always: false }">
        <div v-for="message in messages">
          <li v-if="message.SenderId == senderIdComp" class="right">
            <span class="chat-img pull-left"></span>
            <div class="chat-body clearfix">
              <p class="chat-from">
                {{ message.MessageText }}
                <small style="padding: 5px" class="pull-right"
                  ><span class="glyphicon glyphicon-time"></span
                  >{{ sentDate(message.SentDate) }}</small
                >
              </p>
            </div>
          </li>
          <li v-else class="left clearfix">
            <span class="chat-img pull-right"></span>
            <div class="chat-body clearfix">
              <p class="chat-to">
                {{ message.MessageText
                }}<small style="padding: 5px" class="pull-right"
                  ><span class="glyphicon glyphicon-time"></span
                  >{{ sentDate(message.SentDate) }}</small
                >
              </p>
            </div>
          </li>
        </div>
      </div>
      <div class="input-group">
        <input
          :disabled="preventChat"
          v-model="newMessage"
          class="form-control input-text"
          placeholder="write anything and press send."
          row="3"
          v-on:keyup.enter="sendMessage"
        />
        <span
          :disabled="preventChat"
          @click="sendMessage"
          class="input-group-addon btn"
          >Send</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import auth from "../../auth";
import store from "../../data/store";

const API_URL = "https://www.dupaws.com/services/";
export default {
  name: "chat",
  props: ["transactionId", "preventChat", "isSitterAccepted"],
  data() {
    return {
      sender: "",
      messages: [],
      newMessage: "",
      scrollPosition: "",
    };
  },
  updated() {
    var self = this;
    $("input").focus(function () {
      self.scrollPosition = window.scrollY;
    });
    $("input").blur(function () {
      // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
      self.$SmoothScroll(self.scrollPosition, 350);
    });
  },
  methods: {
    sendMessage: function () {
      var self = this;
      if (this.newMessage.length == 0) {
        return;
      }

      var phoneSuspect = /\d(([\. \- \_\!\@\`\~\+\<\>\,  ]){0,5}?\d){6,12}/;
      // var phoneSuspect = /\d{6}/;
      if (
        phoneSuspect.test(this.newMessage) &&
        this.isSitterAccepted == false
      ) {
        swal(
          "Sharing Numbers",
          "Please do not share phone numbers until the booking is accepted",
          "info"
        );
        return;
      }

      var message = {
        MessageText: this.newMessage,
        SenderId: this.senderIdComp,
      };
      self.signalRHubComp.invoke(
        "SendMessage",
        this.senderIdComp,
        store.getters.userRole,
        message,
        self.transactionId
      );
      self.newMessage = "";
    },
    sentDate: function (date) {
      return moment(date).fromNow();
    },
  },
  beforeDestroy: function () {
    var self = this;
    self.signalRHubComp.invoke("LeaveChat", self.transactionId); //to Join Chat
    clearInterval(this.refreshInterval);
  },
  mounted: function () {
    var self = this;

    $.ajax({
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "Authorization",
          "bearer " + localStorage.getItem("access_token")
        );
      },
      url: API_URL + "api/getReservationMessages/" + self.transactionId,
      dataType: "json",
      crossDomain: true,
      contentType: "application/json; charset=utf-8",
      success: function (data) {
        if (data.length > 0) self.messages = data;
      },
      error: function (data, status, error) {
        console.log("Couldn't get reservation messages" + data.responseText);
      },
    });

    this.refreshInterval = setInterval(function () {
      self.$forceUpdate();
    }, 15000);

    self.signalRHubComp.on("SendMessage", function (message, transId) {
      if (transId == self.transactionId) self.messages.push(message);
    });

    var userId;
    if (store.getters.userRole == "Sitter") {
      userId = store.getters.SitterId;
    } else if (store.getters.userRole == "Client") {
      userId = store.getters.CustomerId;
    }

    self.signalRHubComp.invoke(
      "JoinChat",
      self.transactionId,
      userId,
      store.getters.userRole
    ); //to Join Chat
  },

  computed: {
    senderIdComp: function () {
      if (store.getters.userRole == "Client") return store.getters.CustomerId;
      else return store.getters.SitterId;
    },
    signalRHubComp: function () {
      if (store.getters.SignalRHub != null) return store.getters.SignalRHub;
    },
  },
};
</script>
<style scoped>
.chat {
  background: #fff;
  background-size: 90px;
  list-style: none;
  padding: 10px;
  overflow-y: scroll;
  height: 250px;
  box-shadow: 0 3px #ccc;
  border: 1px;
  border-radius: 5px;
  border-style: solid;
  border-color: #c7c6c6;
  border-radius: 5px;
}

.chat-from {
  background-color: #b8ebcb96;
  border-radius: 8px;
  padding: 10px;
  word-wrap: break-word;
  overflow: hidden;
}

.chat-to {
  background-color: #e2ccf096;
  border-radius: 8px;
  padding: 10px;
  word-wrap: break-word;
  overflow: hidden;
}

.chat li {
  padding-bottom: 10px;
}

.chat li.left .chat-body {
  margin-left: 60px;
}

.chat li.right .chat-body {
  margin-right: 60px;
}

.chat li .chat-body p {
  margin: 0;
  color: #777777;
}

.panel .slidedown .glyphicon,
.chat .glyphicon {
  margin-right: 5px;
}

.panel-body {
  overflow-y: scroll;
  height: 250px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d8d8d8;
}
</style>



// WEBPACK FOOTER //
// Chat.vue?650af3c2